import * as S from "./styles";

function DestinosOrganizado({ origem, destinos }) {
  return (
    <S.DetailLittleBox>
    <S.AddressTimeline >
      {!!origem && origem.formatted_address && (
        <S.TimelineItem>
          <S.Dot color="#F77317" />
          <span>Embarque: {origem.formatted_address}</span>
        </S.TimelineItem>
      )}
      {!!destinos &&
        destinos.map((destino, index) => (
          <S.TimelineItem key={index}>
            <S.Dot color="#F77317" style={{ borderRadius: 0 }} />
            <span>{destinos.length === index + 1 ? "Desembarque": "Parada" }: {destino.formatted_address}</span>
          </S.TimelineItem>
        ))}
    </S.AddressTimeline></S.DetailLittleBox>
  );
}
export default DestinosOrganizado;
